<template>
  <v-container>
      <v-row>
          <v-col>
              <h1 class="text-h2">Gestion des inventaires</h1>
              <h2 id="createproduct" class="text-h4">Création de produits</h2>
              <p>La création de produits se fait dans la liste des produits en cliquand sur "ADD PRODUCT", lors de cette création il faut renseigner les éléments suivants</p>
              <ul>
                  <li><strong>NAME</strong> : Le nom du produit tel qu'afficher dans le Middleware</li>
                  <li><strong>CODE</strong> : Il s'agit d'un code numérique utilisé pour créer les code barre et représentant de manière unique un produit, s'il est vide il est généré automatiquement, et il doit être unique</li>
                  <li><strong>SKU</strong> : Il s'agit du code AlphNumérique utilisé pour identifier rapidement un produit, il peut-être généré automatiquement par le nom du produit, et il doit être unique</li>
                  <li><strong>BRAND</strong> : La marque du produit</li>
                  <li><strong>PRODUCT TYPE</strong> : La catégorie du produit</li>
              </ul>
              <p>Pour des question de simplicité il est possible d'ajouter un produit à un catalogue directement depuis cette fenêtre</p>
              <p>Un produit qui n'est actif dans aucun catalogue ne peut pas être utilisé dans une commande</p>
          </v-col>
      </v-row>
      <v-row>
          <v-col>
              <h3 id="catalog" class="text-h4">Catalogues</h3>
              <p>Le catalogue représente la disponibilité et le prix d'un produit pour un SHOP particulier</p>
              <p>Il faut activer un produit dans le catalogue du shop voulu et lui attribuer un prix de vente pour qu'il soit vendable</p>
              <p>Vous pouvez définir le prix de vente selon deux manières</p>
              <ul>
                  <li><strong>FIX PRICE</strong> : Le prix afficher sera toujours le prix saisie</li>
                  <li><strong>UpCharge</strong> : Le prix est calculé en fonction du prix du produit et du prix du produit de base de la même catégorie</li>
              </ul>
              <p>Si vous cocher la case <strong>VAT Included</strong> la TVA sera déduite sur la facture du client</p>
          </v-col>
      </v-row>
      <v-row>
          <v-col>
              <h3 id="stock" class="text-h4">Gestion du stock d'un produit</h3>
              <p>Dans le détail d'un produit vous pouvez voir le stock à disposition</p>
              <p>Plusieurs valeurs sont calculée</p>
              <ul>
                  <li><strong>Available</strong> : Il s'agit du nombre de produit vendable, il est calculé en fonction du stock réel (on hand) et du stock prévu pour les commandes ouvert (pending)</li>
                  <li><strong>On Hand</strong> : Il s'agit du stock réel de produits dans le dépôt</li>
                  <li><strong>Pending</strong> : Il s'agit du nombre de produits reservé dans des commandes validée</li>
                  <li><strong>Incoming</strong> : Le nombre de produit qui va arriver suite à un Purchase Order</li>
              </ul>
              <p>Vous avez la possiblité de voir où sont stocker les produits et vous pouvez effectuer un transfert de stock à cet endroit</p>
          </v-col>
      </v-row>
      <v-row>
          <v-col>
              <h3 id="warehouse" class="text-h4">Gestion du Warehouse et des Locations</h3>
              <p>Dans la page de gestion des Warehouses vous pouvez gérer l'ensemble des casiers et armoire de stockage dans un dépot</p>
              <p>Un <strong>Warehouse</strong> est un dépôt de produit, il peut contenir plusieurs casiers et armoire</p>
              <p>Un <strong>Location</strong> est un zone d'entreposage des produits, il est possible de créer une arborescence de zone de stockage en choisisant afin d'avoir plusieurs zone et plusieurs détails</p>
              <p>Lors de la création de Location vous pouvez renseigner les valeurs suivantes</p>
              <ul>
                  <li><strong>Warhouse</strong> : Le dépot auquel appartient ce casier</li>
                  <li><strong>Parent</strong> : Choisisez une autre Location afin de créer une arborescence</li>
                  <li><strong>Location</strong> : Le code du casier</li>
                  <li><strong>Container</strong> : Cocher la case s'il s'agit d'un container de gros volume (Pas utilisé encore)</li>
                  <li><strong>Backstock</strong> : Tout les produits stocker dans un casier comme celui-ci ne seront pas comptabilisé dans les inventaires disponible à la vente</li>
                  <li><strong>Reserve</strong> : Les produits sotcker ici seront diposnible à la ventes mais pourrait être plus difficile à attendre car ranger dans une reserve pas disponible directement</li>
              </ul>
          </v-col>
      </v-row>
      <v-row>
          <v-col>
              <h3 id="supplier" class="text-h4">Fournisseurs</h3>
              <p>Vous pouvez gérer la list fournisseurs afin de centraliser les données de commande (numéro de client, information de contact, etc), il est également possible d'envoyer automatiquement un mail de commande lors de la création d'un Purchase Order si les information de contact sont rempli</p>
          </v-col>
      </v-row>
      <v-row>
          <v-col>
              <h3 id="po" class="text-h4">Purchase Order (PO)</h3>
              <p>La création d'un Purchase Order permet de préparer les commandes de produits et le prix d'achat des produits</p>
              <p>Il s'agit de la seule manière de rajouter des produits dans le stock</p>
              <p>Pour créer un PO il faut saisir certaines informations: </p>
              <ul>
                  <li><strong>PO Number</strong> : Il s'agit du numéro de commandes que vous pouvez fournir à vos fournisseurs afin qu'il l'ajoute à leur bon de livraison, ça permet d'identifier un PO</li>
                  <li><strong>Supplier</strong> : Le fourniseurs à qui vous commander ces produits, si les infos de contact du fournisseurs sont saisi, il est possible d'envoyer le mail de commande directement depuis le Middleware</li>
                  <li><strong>Order Date</strong> : Il s'agit de la date à laquelle vous avez envoyer le mail au fournisseur</li>
                  <li><strong>Warehouse</strong> : Le dépôt qui doit recevoir la commande</li>
                  <li><strong>Currency</strong> : Monnaie de la facture</li>
              </ul>
              <p>D'autres information sont renseignable pour un meilleur suivi:</p>
              <ul>
                  <li><strong>Requested Ship Date</strong> : Date à laquelle les produits ont été envoyer par le fournisseurs </li>
                  <li><strong>Sent Status</strong> : Status d'envoi</li>
                  <li><strong>Tracking Info</strong> : Information de tracking</li>
                  <li><strong>Arrival Due Date</strong> : Date d'arrivée attendue</li>
                  <li><strong>Payment Status</strong> : Status du paiement</li>
                  <li><strong>Order Cancel Date</strong> : Date à laquelle la commande a été annulé</li>
              </ul>
              <p>Il faut ensuite ajouter les produits que vous voulez commander dans la liste</p>
              <p>Pour chaque produit il faut renseigner le prix d'achat avant de les receptionner, ça permettra de calculer le prix d'achat moyen des produits en stock et donc de calculer le PnL des ventes effectuée</p>
              <p><strong>Status des PO</strong></p>
              <ul>
                    <li><strong>Draft</strong> : Le PO est en cours de création</li>
                    <li><strong>Validated</strong> : Le PO est validé et envoyé au fournisseurs ( les produits saisi dans le PO sont pris en compte dans le calcul du stock )</li>
                    <li><strong>Partially Received</strong> : Le PO a été réceptionné mais certains produits n'ont pas été livré ou ont été renvoyé au fournisseur</li>
                    <li><strong>Received</strong> : Le PO a été réceptionné</li>
                    <li><strong>Canceled</strong> : Le PO est annulé</li>
              </ul>
          </v-col>
      </v-row>
  </v-container>
</template>

<script>
export default { 

}
</script>

<style>

</style>